declare const ENV: {
  API_URL?: string;
};

export const API_URL = ENV.API_URL || 'https://api.adalong.com';
